import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

export default function CourseGeneratingScreen({ title, progress = 0, message }) {
  const pct = Math.max(3, Math.min(100, Math.round(progress)));
  return (
    <div className="min-h-screen bg-navigate-dark flex items-center justify-center px-6" data-testid="course-generating-screen">
      <div className="w-full max-w-md text-center">
        <span className="mx-auto mb-6 h-14 w-14 rounded-2xl bg-amber-400/10 text-amber-300 flex items-center justify-center animate-pulse">
          <Sparkles className="h-7 w-7" />
        </span>
        <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500 mb-2">NAVI is building this Learning Unit</p>
        {title && <h1 className="text-white text-xl font-semibold mb-6">{title}</h1>}
        <div className="h-2 rounded-full bg-zinc-800 overflow-hidden">
          <div className="h-full rounded-full bg-teal-500 transition-[width] duration-700" style={{ width: `${pct}%` }} data-testid="course-generating-progress" />
        </div>
        <p className="text-sm text-zinc-400 mt-3" data-testid="course-generating-message">{message || 'Generating content…'} · {pct}%</p>
        <p className="text-xs text-zinc-500 mt-6">This page opens the course automatically when it's ready. You can also leave and come back later.</p>
        <Link to="/admin/programmes" className="inline-block mt-4 text-sm text-amber-300 hover:text-amber-200" data-testid="course-generating-back">Back to Programmes</Link>
      </div>
    </div>
  );
}
